import { render } from "./NokoriPage.vue?vue&type=template&id=4aefdac8&scoped=true"
import script from "./NokoriPage.vue?vue&type=script&lang=js"
export * from "./NokoriPage.vue?vue&type=script&lang=js"

import "./NokoriPage.vue?vue&type=style&index=0&id=4aefdac8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aefdac8"]])

export default __exports__